/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react'
import {
    Create,
    Edit,
    required,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
    NumberInput,
    DateInput,
    useDataProvider,
    AutocompleteInput,
} from 'react-admin'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import BackButton from '../../components/BackButton'
import Title from '../../components/Title/Title'
import '../style.css'
import CustomValidater from '../../components/Utility/Validater'

const EOBIRateSetupComponent = (props) => {
    const user = useSelector((state) => state.auth)
    const userData = {
        created_by: user.description,
        modified_by: user.description,
    }
    const { title, eobiType } = props
    return (
        <SimpleForm
            validate={(values) => CustomValidater(values, props)}
            style={{ width: '100%' }}
            {...props}
            variant="outlined"
            warnWhenUnsavedChanges
            initialValues={userData}
        >
            <Title title={title} />
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                }}
            >
                <div style={{ flex: 0.6 }}>
                    <div className="container">
                        <AutocompleteInput
                            source="eobitype_id"
                            label="EOBI Type Id"
                            optionText="description"
                            optionValue="id"
                            variant="outlined"
                            choices={eobiType}
                            validate={required()}
                        />
                    </div>
                    <div className="container">
                        <DateInput
                            style={{ display: 'flex', flex: 0.8 }}
                            variant="outlined"
                            source="date_wef"
                        />
                    </div>
                    <div className="container">
                        <NumberInput
                            style={{ display: 'flex', flex: 0.8 }}
                            variant="outlined"
                            label="Minimum Wage"
                            source="minimum_wage"
                            validate={required()}
                        />
                    </div>
                    <div className="container">
                        <NumberInput
                            style={{ display: 'flex', flex: 0.8 }}
                            variant="outlined"
                            label="Employer Contribution"
                            source="employer_contribution"
                            validate={required()}
                        />
                    </div>
                    <div className="container">
                        <NumberInput
                            style={{ display: 'flex', flex: 0.8 }}
                            variant="outlined"
                            label="Employee Contribution"
                            source="employee_contribution"
                            validate={required()}
                        />
                    </div>
                </div>
                <div style={{ flex: 0.3 }}>
                    <div className="container">
                        <TextInput
                            style={{ display: 'flex', flex: 1 }}
                            variant="outlined"
                            disabled
                            label="Created By"
                            source="created_by"
                            validate={required()}
                        />
                    </div>
                    <div className="container">
                        <TextInput
                            style={{ display: 'flex', flex: 1 }}
                            variant="outlined"
                            disabled
                            label="Modified By"
                            source="modified_by"
                            validate={required()}
                        />
                    </div>
                </div>
            </div>
        </SimpleForm>
    )
}

export default function CreateEOBIRateSetup(props) {
    const [eobiType, setEOBIType] = useState([])
    const notify = useNotify()
    const refresh = useRefresh()
    const redirect = useRedirect()
    const { isEdit } = props
    const onSuccess = () => {
        notify(`Changes saved`, { type: 'success' })
        redirect('/PY_EOBIRateTAB')
        refresh()
    }

    const dataProvider = useDataProvider()

    useEffect(() => {
        dataProvider.getList('PY_EOBITypeTAB', {}).then(({ data }) => {
            setEOBIType(data)
        })
    }, [dataProvider])

    if (isEdit)
        return (
            <>
                <BackButton path="/PY_EOBIRateTAB" />
                <Edit {...props} undoable={false}>
                    <EOBIRateSetupComponent
                        title="Edit EOBI Rate Setup"
                        isEdit
                        eobiType={eobiType}
                    />
                </Edit>
            </>
        )
    return (
        <>
            <BackButton path="/PY_EOBIRateTAB" />
            <Create onSuccess={onSuccess} {...props}>
                <EOBIRateSetupComponent
                    title="Create EOBI Rate Setup"
                    isEdit={false}
                    eobiType={eobiType}
                />
            </Create>
        </>
    )
}

CreateEOBIRateSetup.propTypes = {
    isEdit: PropTypes.bool.isRequired,
}

EOBIRateSetupComponent.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    eobiType: PropTypes.string.isRequired,
}
